module.exports = __webpack_public_path__ + "media/images/landing__seasonPrize__prize2-6f3bebdd9f3fd715b236b02a3948316d.jpg";